import { z } from "zod";
import { GENERATION_RATIOS } from "../../../Board/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

const zBriefSettings = z.object({
  prompt: z.string().default(""),
  generation_ratio: z.enum(GENERATION_RATIOS).nullable().default(null),
  enforce_photo: z.boolean().default(false),
  photo_enabled: z.boolean().default(false),
});

export const briefSettingsStorage = settingsStorageFactory(
  "brief-settings",
  2,
  zBriefSettings,
  () => zBriefSettings.omit({ prompt: true, generation_ratio: true }).parse({}),
);
